// extracted by mini-css-extract-plugin
module.exports = {"main_page":"TopBuySell_main_page__3hbzD","main_header":"TopBuySell_main_header__I8yNt","content":"TopBuySell_content__s3bjs"};